import { render, staticRenderFns } from "./UserAlert.vue?vue&type=template&id=bcf4cf52&"
import script from "./UserAlert.vue?vue&type=script&lang=js&"
export * from "./UserAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports